import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "react-oidc-context";

import { hasBackofficeRole } from "utils/authRoles";

const UnprotectedRoute = () => {
  const auth = useAuth();
  const { isAuthenticated, isLoading } = auth;

  if (isLoading) {
    return null;
  }

  if (isAuthenticated) {
    if (hasBackofficeRole(auth.user?.profile)) {
      return <Navigate to="/dealers/manage" />;
    }

    return <Navigate to="/unauthorized" />;
  }

  return <Outlet />;
};

export default UnprotectedRoute;
